import { constants } from "../../misc/constants";
import Scenario2 from "./Scenario2";
import { SbarUIConfig } from "../../components/ui/SbarUI";
import { TransformUIConfig } from "../../components/ui/TransformUI";
import MedsurgBaseScenarioPart from "../MedsurgBaseScenarioPart";
import { Window508Type } from "../MedsurgBaseScenario";

export default class Scenario2Part9 extends MedsurgBaseScenarioPart {

	chapterIds = {
		chapterCinematic1: 'medsurg-cinematic-2-1',
        chapterCinematic63: 'medsurg-cinematic-2-63',
        chapterCinematic64: 'medsurg-cinematic-2-64',
		chapterCinematic71: 'medsurg-cinematic-2-71',
        chapterCinematic72: 'medsurg-cinematic-2-72',
        chapterCinematic73: 'medsurg-cinematic-2-73',
        chapterCinematic74: 'medsurg-cinematic-2-74',
        chapterCinematic75: 'medsurg-cinematic-2-75',
        chapterCinematic60: 'medsurg-cinematic-2-60',
		chapterCinematic82: 'medsurg-cinematic-2-82',
		chapterCinematic59: 'medsurg-cinematic-2-59',
	}

	constructor(scenario: Scenario2, private onDone: () => void){
		super(scenario);
	}

	private PrInstanceID: string;
	private TalkInstanceID1: string;
	private ActionInstanceID1: string;
	private ActionInstanceID2: string;
	private ActionInstanceID3: string;
	private RememberDisplayed: boolean = false;
	private MoveInstanceID: string;

	private Talk1: boolean = false;
	private Talk2: boolean = false;
	private Talk3: boolean = false;
	private Talk4: boolean = false;
	private Action1: boolean = false;
	private Action2: boolean = false;
	private Action3: boolean = false;
	private Action4: boolean = false;
	private Action5: boolean = false;
	private Action6: boolean = false;
	private Action7: boolean = false;
	private Action11: boolean = false;
	private Action12: boolean = false;
	private Action13: boolean = false;
	private Action14: boolean = false;
	private Action15: boolean = false;
	private Action51: boolean = false;
	private Action52: boolean = false;
	private Action53: boolean = false;
	private Action54: boolean = false;

	private TalkCount: number = 0;
	private OldTalkCount: number = 0;
	private ActionCount: number = 0;
	private OldActionCount: number = 0;
	private PAbool: boolean = false;
	private DRbool: boolean = false;

	
	public get partId(): string {
		return constants.scenarios.scenario2.parts.level2Part9.id;
	}

	public get videoUrl(): string[] {
		//return ['./assets/videos/scenario2/video3' + this.scenario.avatarIndx + '.mp4'];
		return ['./assets/videos/scenario2/video30.mp4'];
	}

	public start() {
		const context = this;
		this.RememberDisplayed = false;
		context.segment1Step1IntroWalking();
	}

	private segment1Step1IntroWalking() {
		var context = this;
		this.scenario.playAmbientLoop(this.scenario.audioHall);
		this.scenario.destroyAllUIInstances();
		context.scenario.displayHeader();
		this.playVideoChapter(this.chapterIds.chapterCinematic1, () => {
			context.segment1Step2ContinueRoom1();
		});
    }

	private segment1Step4Remember() {
		var context = this;
		this.scenario.update508Window(Window508Type.Remember);
		this.scenario.displayRemember(() => {
			this.scenario.update508Window(Window508Type.Main);
			this.RememberDisplayed = true;
			context.scenario.destroyAllUIInstances();
			//context.skipPart();
		});
	}
	//use when skipping part for testing
	private skipPart() {
		var context = this;
        this.scenario.displayModalPop(
			null,
            'Skipping to End',
            () => {
                context.scenario.destroyAllUIInstances();
                    context.segment1StepFinal();
            }
        );
	}

    private segment1Step2ContinueRoom1() {
		this.scenario.destroyAllUIInstances();
        var context = this;
        context.scenario.gameManager.environment.blurFadeIn();
        this.scenario.displayModalPop(
			null,
            "Mr. Ramirez is due for his 3rd rounds assessment.",
            () => {
				this.scenario.stopAmbientLoop();
				this.scenario.playAmbientLoop(this.scenario.audioRoom);
				context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				this.playVideoChapter(this.chapterIds.chapterCinematic63, () => {}, true);
                context.PreloadUis();
				if(this.RememberDisplayed === false) {
					context.segment1Step4Remember();
				}
				this.scenario.displayFooter(() => this.PrInstanceID, () => this.TalkInstanceID1, () => this.ActionInstanceID1, '4', '1', false, false);
				context.TalkCount = 4;
				context.ActionCount = 1;
				context.getFooterCounts();
            }
        );
    }

	private segment1Part5Debrief() {
		var context = this;
		context.scenario.displayDebrief(6450, () => {
			localStorage.setItem('ignoreResumePopup', 'true');
			window.location.reload();
		}, () => {
			context.segment1StepFinal();
		});
	}

	private segment1StepFinal() {
        var context = this;
        context.scenario.destroyAllUIInstances();
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;
		context.scenario.saveScore();
		context.segment1Part5DebriefFinal();
    }

	private segment1Part5DebriefFinal() {
		var context = this;
		this.scenario.stopAmbientLoop();
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;
		context.scenario.saveScore();
		context.scenario.displayFinalDebrief(false, 44050, () => {
			localStorage.setItem('ignoreResumePopup', 'false');
			window.location.reload();
		});
	}

    public PreloadUis(shouldHidePatientRecord?: boolean) {
        var context = this;
        this.PrInstanceID = (this.scenario as Scenario2).PrRamirezID;
		context.scenario.gameManager.UiManager.updateUIInstance(this.PrInstanceID, {
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.Remember);
				}, 500);
				this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
				// if(this.RememberDisplayed === false) {
				// 	context.segment1Step4Remember();
				// }
			}
		})

		if(shouldHidePatientRecord) {
			this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
		} else {
			setTimeout(() => {
				context.scenario.update508Window(Window508Type.PatientRecord);
			}, 500);
		}

		(this.scenario as Scenario2).PrRamirezID = this.PrInstanceID;

		context.TalkInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Talk',
			talks: [
				{
					toppx: '50px',
					titletext: 'How are you feeling?',
					onClicked: () => {
						this.segment1TalkFeeling();
					},
					disable: () => this.Talk1
				},
				{
					toppx: '150px',
					titletext: 'On a scale of 0-10, can you rate your pain?',
					onClicked: () => {
						this.segment1TalkRate();
					},
					disable: () => this.Talk2
				},
				{
					toppx: '250px',
					titletext: 'Can you describe your pain?',
					onClicked: () => {
						this.segment1TalkDescribe();
					},
					disable: () => this.Talk3
				},
				{
					toppx: '350px',
					titletext: 'Would you like something for the pain?',
					onClicked: () => {
						this.segment1TalkPills();
					},
					disable: () => this.Talk4
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);

		this.ActionInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Action',
			talks: [
				{
					toppx: '50px',
					titletext: 'Take Vitals',
					onClicked: () => {
						this.segment1ActionVitals();
					},
					disable: () => this.Action1
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
	}

	private segment1ActionVitals() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID2 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Take Vitals',
			talks: [
				{
					toppx: '50px',
					titletext: 'Temperature',
					onClicked: () => {
						context.segment1ActionTemperature();
					},
					disable: () => this.Action11
				},
				{
					toppx: '150px',
					titletext: 'Blood Pressure',
					onClicked: () => {
						context.segment1ActionBloodPressure();
					},
					disable: () => this.Action12
				},
				{
					toppx: '250px',
					titletext: 'Pulse',
					onClicked: () => {
						context.segment1ActionPulse();
					},
					disable: () => this.Action13
				},
				{
					toppx: '350px',
					titletext: 'Respirations',
					onClicked: () => {
						context.segment1ActionRespirations();
					},
					disable: () => this.Action14
				},
				{
					toppx: '450px',
					titletext: 'O2 Sat Level',
					onClicked: () => {
						context.segment1ActionSatLevel();
					},
					disable: () => this.Action15
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1TalkFeeling() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '70px',
			loadQuiz: true,
			titletext: 'How are you feeling?',
			isTalks: true,
			extBottom: true,
			extText: "A little better, I guess. My chest still hurts, but not as badly. My arm hurts, too.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk1 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 150,
					talktext1: 'Patient Assessment',
					talktext2: 'Pain Location',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'General',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Arm(s)',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Leg(s)',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Head',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Chest',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic71, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic63, () => {}, true);
		});
	}

	private segment1TalkRate() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '170px',
			loadQuiz: true,
			titletext: 'On a scale of 0-10, can you rate your pain?',
			isTalks: true,
			isPainScale: true,
			painScaleMaxPoints: 100,
			painScaleCorrect: 6,
			extBottom: true,
			extText: "About a 6, I suppose. Like I said, it's a little better than before, but not a whole lot.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.evaluateScoreForPainScale(updatedConfig);
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4);
					this.PAbool = true;
				}
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
					header: 'Pain Scale',
					list: '<li>'+updatedConfig.painAssessment+'</li>',
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4, context.scenario.patientAssessment)
				this.Talk2 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic72, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic63, () => {}, true);
		});
	}

	private segment1TalkDescribe() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '270px',
			loadQuiz: true,
			titletext: 'Can you describe your pain?',
			isTalks: true,
			extBottom: true,
			extText: "My chest feels really bruised and tender. My arm is throbbing.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk3 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 150,
					talktext1: 'Pain Assessment',
					talktext2: 'Pain Description',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Stabbing',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Burning',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Sharp',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Tender',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Throbbing',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic73, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic63, () => {}, true);
		});
	}

	private segment1TalkPills() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '370px',
			loadQuiz: true,
			titletext: 'Would you like something for the pain?',
			isTalks: true,
			extBottom: true,
			extText: "Yes, please. That would be good.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
					title: context.scenario.medicineAdministered,
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4, context.scenario.medicineAdministered)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk4 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 100,
					binaryq: true,
					talktext1: 'Medication Administered',
					talktext2: ' ',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Yes',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic74, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic63, () => {}, true);
		});
	}

	private segment1ActionTemperature() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '70px',
			loadQuiz: true,
			titletext: 'Temperature',
			vitaltext: '98.4',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_temp.png',
			onSubmit: () => {
				this.Action11 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
					list: '<li>Temperature : 98.4</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionBloodPressure() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '170px',
			loadQuiz: true,
			titletext: 'Blood Pressure',
			vitaltext: '112/74',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_bp.png',
			onSubmit: () => {
				this.Action12 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
					list: '<li>Blood Pressure : 112/74</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionPulse() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '270px',
			loadQuiz: true,
			titletext: 'Pulse',
			vitaltext: '82',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_pulse.png',
			onSubmit: () => {
				this.Action13 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
					list: '<li>Pulse : 82</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionRespirations() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '370px',
			loadQuiz: true,
			titletext: 'Respirations',
			vitaltext: '20',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_respiration.png',
			onSubmit: () => {
				this.Action14 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
					list: '<li>Respirations : 20</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionSatLevel() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '470px',
			loadQuiz: true,
			titletext: 'O2 Sat Level',
			vitaltext: '95% 2L supplemental O2',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_o2.png',
			onSubmit: () => {
				this.Action15 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
					list: '<li>02 Sat Level : 95% 2L supplemental O2</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.segment2PreloadUis();
		}
		else if(this.TalkCount === 0 && this.ActionCount !== 0) {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		}
		else if(this.TalkCount !== 0 && this.ActionCount === 0) {
			context.scenario.updateFooter(this.TalkCount.toString(), '0', false, true);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), false, false)
		};
	}

	private checkIfSubMenu() {
		var context = this;
		if(this.Action11 === true && this.Action12 === true && this.Action13 === true && this.Action14 === true && this.Action15 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			this.Action1 = true;
			this.ActionCount = this.OldActionCount - 1;
		};
		context.getFooterCounts();
	}

	private segment2PreloadUis() {
        var context = this;
		context.scenario.gameManager.UiManager.updateUIInstance(this.ActionInstanceID1, {
			talks: [
				{
					toppx: '50px',
					titletext: 'Please take a deep breath and then cough',
					onClicked: () => {
						context.segment2ActionCough();
					},
					disable: () => this.Action2
				},
				{
					toppx: '150px',
					titletext: 'Assess Respiratory Status',
					onClicked: () => {
						context.segment2ActionStatus();
					},
					disable: () => this.Action3
				},
				{
					toppx: '250px',
					titletext: 'Assess chest tube dressing',
					onClicked: () => {
						context.segment2ActionDressing();
					},
					disable: () => this.Action4
				},
				{
					toppx: '350px',
					titletext: 'Assess Patient',
					onClicked: () => {
						context.segment2ActionAssess();
					},
					disable: () => this.Action5
				},
				{
					toppx: '450px',
					titletext: 'Mark Level on Unit',
					onClicked: () => {
						context.segment2ActionMark();
					},
					disable: () => this.Action6
				}
			]
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);

		context.ActionCount = 8;
		context.getFooterCounts2();
	}

	private segment2ActionAssess() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.ActionInstanceID3 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Assess Patient',
			talks: [
				{
					toppx: '50px',
					titletext: 'Assess Chest Tube and System: Suction',
					onClicked: () => {
						context.segment2ActionSuction();
					},
					disable: () => this.Action51
				},
				{
					toppx: '150px',
					titletext: 'Assess Chest Tube and System: Drainage Color and Volume',
					onClicked: () => {
						context.segment2ActionColor();
					},
					disable: () => this.Action52
				},
				{
					toppx: '250px',
					titletext: 'Assess Chest Tube and System: Tidaling',
					onClicked: () => {
						context.segment2ActionTidaling();
					},
					disable: () => this.Action53
				},
				{
					toppx: '350px',
					titletext: 'Assess Chest Tube and System: Leakage',
					onClicked: () => {
						context.segment2ActionLeakage();
					},
					disable: () => this.Action54
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment2ActionCough() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '70px',
			loadQuiz: true,
			titletext: 'Please take a deep breath and then cough.',
			isTalks: true,
			onSubmit: () => {
				context.scenario.updateScore(250);
				this.Action2 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic75, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic63, () => {}, true);
		});
	}

	private segment2ActionStatus() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '170px',
			loadQuiz: true,
			titletext: "Assess Respiratory Status",
			isTalks: true,
			extBottom: true,
			extText: 'Right side: breath sounds are decreased <br>Left Side: breath sounds are normal',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
					title: context.scenario.respiratoryStatus,
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4, context.scenario.respiratoryStatus)
					}
				}
				this.playVideoChapter(this.chapterIds.chapterCinematic63, () => {}, true);
				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action3 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 150,
					binaryq: true,
					talktext1: 'Respiratory Status',
					talktext2: 'Thoracic Cage Expansion',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Symmetrical',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Asymmetrical',
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 4,
					prequizheight: 2,
					quiztop: '310px',
					maxPoints: 150,
					talktext1: 'Respiratory Status',
					talktext2: 'Breath Sounds',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Absent',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Clear on both sides',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Decreased on left, clear on right',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Decreased on right, clear on left',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic64, () => {}, true);
	}

	private segment2ActionDressing() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '270px',
			loadQuiz: true,
			titletext: "Assess chest tube dressing",
			isTalks: true,
			extTop: true,
			extImg: 't24', //NEED IMAGE
			extText: 'Crepitus is not present',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
					title: context.scenario.chestTube,
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4, context.scenario.chestTube)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action4 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 50,
					talktext1: 'Chest Tube and System',
					talktext2: 'Insertion Site',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Bleeding',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Air leakage',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Infection',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Clean and Dry',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 2,
					prequizheight: 4,
					quiztop: '310px',
					maxPoints: 50,
					binaryq: true,
					talktext1: 'Chest Tube and System',
					talktext2: 'Is Crepitus present?',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Yes',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionSuction() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '70px',
			loadQuiz: true,
			titletext: "Assess Chest Tube and System: Suction",
			isTalks: true,
			extTop: true,
			extTopVideo: './assets/videos/general/loop2.mp4',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.DRbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.drainageSystem,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4);
					this.DRbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4, context.scenario.drainageSystem)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action51 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 3,
					quiztop: '5px',
					maxPoints: 200,
					binaryq: true,
					talktext1: 'Drainage System',
					talktext2: 'Suction',
					talks: [
						{
							buttontop: '150px',
							buttontext: '-10 cm',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: '-20 cm',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: '-40 cm',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionColor() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '170px',
			loadQuiz: true,
			titletext: "Assess Chest Tube and System: Drainage Color and Volume",
			isTalks: true,
			extTop: true,
			extTopVideo: './assets/videos/general/loop2.mp4',
			extText: 'Previous shift output is 400mL in 12 hours',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.DRbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.drainageSystem,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4);
					this.DRbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4, context.scenario.drainageSystem)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action52 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 150,
					talktext1: 'Drainage System',
					talktext2: 'Drainage Color',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Dark red',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Pink',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Clear',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Cloudy',
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 5,
					prequizheight: 4,
					quiztop: '410px',
					maxPoints: 150,
					binaryq: true,
					talktext1: 'Drainage System',
					talktext2: 'Drainage Volume',
					talks: [
						{
							buttontop: '150px',
							buttontext: '0 mL',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: '50 mL',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: '100 mL',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: '600 mL',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: '700 mL',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionTidaling() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '270px',
			loadQuiz: true,
			titletext: "Assess Chest Tube and System: Tidaling",
			isTalks: true,
			extTop: true,
			extTopVideo: './assets/videos/general/loop2.mp4',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.DRbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.drainageSystem,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4);
					this.DRbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4, context.scenario.drainageSystem)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action53 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 200,
					binaryq: true,
					talktext1: 'Drainage System',
					talktext2: 'Tidaling',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Present',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Not present',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionLeakage() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '370px',
			loadQuiz: true,
			titletext: "Assess Chest Tube and System: Leakage",
			isTalks: true,
			extTop: true,
			extTopVideo: './assets/videos/general/loop2.mp4',
			extText: 'There is no air leakage',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.DRbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.drainageSystem,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4);
					this.DRbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4, context.scenario.drainageSystem)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action54 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 3,
					quiztop: '5px',
					maxPoints: 200,
					binaryq: true,
					talktext1: 'Drainage System',
					talktext2: 'Leakage',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Presistent leakage',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Intermittent leakage',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'No air leakage',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionMark() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Actions',
			toppx: '470px',
			loadQuiz: true,
			titletext: "Mark Level on Unit",
			isTalks: true,
			extTop: true,
			extTopVideo: './assets/videos/general/loop2.mp4',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
					title: 'What is the total amount of drainage for your shift?',
					header: 'Mark Level on Unit',
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit4)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action6 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 500,
					binaryq: true,
					talktext1: 'What is the total amount of drainage for your shift?',
					talktext2: ' ',
					talks: [
						{
							buttontop: '150px',
							buttontext: '0 mL',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: '50 mL',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: '100 mL',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: '600 mL',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: '700 mL',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts2() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.hideFooter();
			context.segment1EndingPrep();
		}
		else {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false)
		};
	}

	private checkIfSubMenu2() {
		var context = this;
		if(this.Action51 === true && this.Action52 === true && this.Action53 === true && this.Action54 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			this.Action5 = true;
		};
		context.getFooterCounts2();
	}

	private segment1EndingPrep() {
		var context = this;
		this.scenario.displayModalPop(
			null,
			'Your shift is over. Please provide SBAR handoff to the next shift nurse.',
			() => {
				context.scenario.destroyAllUIInstances();
				context.segment3PreloadUis();
			}
		);
	}

	private segment3PreloadUis() {
        var context = this;
		context.scenario.gameManager.UiManager.updateUIInstance(this.ActionInstanceID1, {
			talks: [
				{
					toppx: '50px',
					titletext: 'Provide SBAR handoff to oncoming nurse',
					onClicked: () => {
						this.segment3ActionHandoff();
					},
					disable: () => this.Action7
				}
			]
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);

		context.ActionCount = 1;
		context.TalkCount = 0;
		context.getFooterCounts3();
	}

	private segment3ActionHandoff() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '70px',
			loadQuiz: true,
			titletext: 'Provide SBAR handoff to oncoming nurse.',
			isTalks: true,
			onSubmit: () => {
				context.scenario.updateScore(50);
				this.Action7 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.getFooterCounts3();
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts3() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		context.scenario.updateFooter('0', '0', true, true);
		context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
		context.scenario.update508Window(Window508Type.Main);
		context.scenario.hideFooter();
		context.segment3PartEndingStart();
	}

	private segment3PartEndingStart() {
		var context = this;
		context.scenario.gameManager.environment.blurFadeIn();
		setTimeout(() => {
			this.playVideoChapter(this.chapterIds.chapterCinematic59, () => {});
		}, 1000)
		setTimeout(() => {
			context.scenario.gameManager.environment.blurFadeOut();
			context.scenario.showProvider(
				"Hi, I'm Sue. I'll be Mr. Ramirez's nurse for the next shift. Can we go ahead and get a bedside report?",
				() => {
					context.segment3showSbar();
				}
			);
		}, 1500);
	}

	private segment3showSbar() {
		var context = this;
		context.scenario.update508Window(Window508Type.SbarUI)
		this.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.SbarUI, {
			s: {
				maxPoints: 250,
				options: [
					{
						text: 'previous chest tube dislodged and replaced',
						isCorrect: true
					},
					{
						text: 'previous tube kinking',
						isCorrect: true
					},
					{
						text: 'previous tension pneumothorax',
						isCorrect: false
					},
					{
						text: 'infected insertion site',
						isCorrect: false
					},
					{
						text: 'total drainage for shift was 700 mL',
						isCorrect: true
					}
				]
			},
			basic: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).ramirezBasicID),
			nurses: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario2).ramirezNursesID),
			r: {
				maxPoints: 250,
				options: [
					{
						text: 'Perform drainage system assessment every two hours',
						isCorrect: true
					},
					{
						text: 'Vitals every four hours and as needed',
						isCorrect: true
					},
					{
						text: 'Perform drainage system assessment every four hours',
						isCorrect: false
					},
					{
						text: 'Transfer to ICU',
						isCorrect: false
					},
					{
						text: 'Increase suction',
						isCorrect: false
					}
				]
			},
			correctFeedback: 'Good job, you have correctly relayed critical information. Please review the SBAR and continue.',
			incorrectFeedback: 'You have incorrectly relayed critical information. Accurate patient information ensures patient safety and quality care provided by medical staff and Providers. Please continue to review the corrected SBAR.',
			onSubmitted: (result: SbarUIConfig) => {
				this.scenario.evaluateScoreForSbar(result);
			},
			onClose: (result: SbarUIConfig) => {
				context.scenario.destroyAllUIInstances();
				this.playVideoChapter(this.chapterIds.chapterCinematic59, () => {});
				context.scenario.showProvider(
					"Thanks! That's helpful. I'm sure we'll do fine.",
					() => {
						context.scenario.gameManager.environment.blurFadeOut();
						context.segment1Part5Debrief();
					}
				);
			},
			onSetWindow: (window: Window508Type) => {
				context.scenario.update508Window(window);
			}
		});
	}
}